import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  cross: function cross(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      color: ", ";\n      cursor: pointer;\n      height: 8px;\n      line-height: 0;\n      padding: ", ";\n      position: absolute;\n      right: 0;\n      top: 0;\n      width: 8px;\n      box-sizing: content-box;\n\n      &:hover {\n        color: ", ";\n      }\n    "])), t.tooltipCloseBtnColor, t.tooltipCloseBtnPadding, t.tooltipCloseBtnHoverColor);
  },
  tooltipContent: function tooltipContent(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n      padding: ", " ", ";\n      position: relative;\n    "])), t.tooltipTextColor, t.tooltipPaddingY, t.tooltipPaddingX);
  }
});